<template>
    <div class="card bs-5 mb-5">

        <div class="fl-te-c pb-3">
            <h4>PRIVACY & POLICY</h4>
            <div>
                <btn color="success" icon="fa fa-plus" size="md" @click="$refs.privacyAndPolicyAddModal.show()"
                     text="Add"/>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-3">
                <validated-input label="Search" v-model="ext_search"/>
            </div>
        </div>

        <custom-vue-table class="d-sm-none-lg-block" :show-search-box="false" :fields="fields" :url="listUrl"
                          :per-page="10" ref="table" :extra-params="{ext_search}">

<!--            <template #is_main="{rowData}">-->
<!--                <p v-if="rowData.is_main">Yes</p>-->
<!--                <p v-else>No</p>-->
<!--            </template>-->

            <template #is_enabled="{rowData}">
                <p v-if="rowData.is_enabled">Yes</p>
                <p v-else>No</p>
            </template>

            <template #actions="{rowData}">
                <div class="btn-group-tight">
                    <edit-btn icon="fa fa-eye" text="View" @click="viewDetails(rowData.id)"/>
                    <delete-btn design="basic" @click="setDelete(rowData)"/>
                </div>
            </template>

        </custom-vue-table>
        <privacy-policy-mobile-view :ext_search="ext_search" ref="privacyPolicyMobileView" @viewDetails="viewDetails" @setDelete="setDelete"
                                    class="d-lg-none"></privacy-policy-mobile-view>

        <modal title="Add Privacy And Policy" ref="privacyAndPolicyAddModal" width="50r" :no-close-on-backdrop="true"
               header-color="primary">
            <AddPrivacyAndPolicy @success="formSuccess"></AddPrivacyAndPolicy>
        </modal>

        <modal title="Edit Privacy And Policy" ref="privacyAndPolicyEditModal" :no-close-on-backdrop="true" width="50r"
               header-color="primary">
            <EditPrivacyAndPolicy :initial-data="editingItem" @success="formSuccess"></EditPrivacyAndPolicy>
        </modal>

        <delete-modal ref="privacyAndPolicyDeleteModal" :url="deleteUrl" :params="deletingItem"
                      @response="deleteComplete">
            <p>You are about to delete the Privacy & Policy <b
                v-html="deletingItem && deletingItem.policy_document"></b>. Are you sure ?
            </p>

            <template #loading>
                <loading-animation/>
                Please wait while we delete <b v-html="deletingItem && deletingItem.policy_document"></b>.
            </template>
        </delete-modal>

    </div>
</template>

<script>
import urls from '@/data/cms-urls';
import AddPrivacyAndPolicy from './AddPrivacyAndPolicy';
import EditPrivacyAndPolicy from './EditPrivacyAndPolicy';
import PrivacyPolicyMobileView from '@/views/cms/privacy-and-terms/privacy-and-policy/PrivacyPolicyMobileView';

export default {
    name : 'PrivacyAndPolicy',

    components : { PrivacyPolicyMobileView, AddPrivacyAndPolicy, EditPrivacyAndPolicy },

    data () {
        return {
            ext_search : '',
            listUrl    : urls.cms.privacyPolicy.list,
            deleteUrl  : urls.cms.privacyPolicy.delete,

            editingItem  : null,
            deletingItem : null,

            fields : [
                {
                    name      : 'order',
                    sortField : 'order',
                    title     : 'Order'
                },
                {
                    name      : 'title',
                    sortField : 'title',
                    title     : 'Title'
                },
                {
                    name      : 'created_at',
                    sortField : 'created_at',
                    title     : 'Created At'
                },
                {
                    name  : '__slot:is_enabled',
                    title : 'Enabled'
                },
                {
                    name       : '__slot:actions',
                    title      : 'Actions',
                    titleClass : 'center bg-gray aligned text-right',
                    dataClass  : 'center aligned text-right'
                }
            ]
        };
    },
    methods : {
        viewDetails (id) {
            this.$router.push('/cms/privacy-and-policy/' + id + '/details/');
        },
        formSuccess () {
            const refs = this.$refs;
            refs.privacyAndPolicyAddModal.close();
            refs.privacyAndPolicyEditModal.close();
            refs.privacyPolicyMobileView.loadData();
            refs.table.refreshTable();

            this.editingItem = null;
        },

        setEdit (item) {
            this.editingItem = { ...item };
            this.$refs.privacyAndPolicyEditModal.show();
        },

        setDelete (item) {
            this.deletingItem = { ...item };
            this.$refs.privacyAndPolicyDeleteModal.show();
        },

        deleteComplete (response) {
            if (response.error === true) {
                if (response.message) {
                    this.$notify(response.message, 'Failed', { type : 'danger' });
                } else {
                    this.$notify('Failed to delete, Please try again later', 'Failed',
                        { type : 'danger' }
                    );
                }
            } else {
                this.$notify('Successfully Deleted..!', 'Success', { type : 'success' }
                );
            }
            this.deletingItem = null;
            this.$refs.privacyAndPolicyDeleteModal.close();
            this.$refs.privacyPolicyMobileView.loadData();
            this.$refs.table.refreshTable();
        }

    }
};
</script>

<style scoped>

</style>
